// change this

export const config = {
  //DEV_BASE_URL: "https://dev-kitab-metadata-api.azurewebsites.net",
  //DEV_BASE_URL: "http://127.0.0.1:8000",
  DEV_BASE_URL: "https://labelstudio.kitab-project.org/kitab-api",
  PROD_BASE_URL: "https://kitab-metadata-api.azurewebsites.net",
  DEV_ENV: false,
  GITHUB_BASE_URL: "https://github.com/OpenITI",
  GITHUB_BASE_RAW_URL: "https://raw.githubusercontent.com/OpenITI",
  KITAB_DEV_URL: "https://dev.kitab-project.org",
  THIS_BASE_URL: "https://green-stone-06c3c5810.3.azurestaticapps.net/",
  ONE_TO_ALL_URL:
    "https://raw.githubusercontent.com/kitab-project-org/one_to_all/",
  GITHUB_PAIRWISE_URL:
    "https://raw.githubusercontent.com/kitab-project-org/pairwise-light",
};
